export const defaultCategoryName = 'Other';
export const transactionSideOptions = [
  { label: 'Dual', value: 'dual', default: true },
  { label: 'Sell/Owner Side', value: 'sell_side' },
  { label: 'Buyer/Tenant Side', value: 'buy_side' },
];
